/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnagrafeDTO } from './AnagrafeDTO';
import {
    AnagrafeDTOFromJSON,
    AnagrafeDTOFromJSONTyped,
    AnagrafeDTOToJSON,
} from './AnagrafeDTO';
import type { CicloDTO } from './CicloDTO';
import {
    CicloDTOFromJSON,
    CicloDTOFromJSONTyped,
    CicloDTOToJSON,
} from './CicloDTO';

/**
 * 
 * @export
 * @interface DocumentoDTO
 */
export interface DocumentoDTO {
    /**
     * 
     * @type {number}
     * @memberof DocumentoDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentoDTO
     */
    idCiclo?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentoDTO
     */
    idAnagrafeMittente?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentoDTO
     */
    idAnagrafeDestinatario?: number;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoDTO
     */
    dataDocumento?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentoDTO
     */
    numeroDocumento?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoDTO
     */
    dataOperazione?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentoDTO
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentoDTO
     */
    tipo?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentoDTO
     */
    idArxivar?: number | null;
    /**
     * 
     * @type {CicloDTO}
     * @memberof DocumentoDTO
     */
    ciclo?: CicloDTO;
    /**
     * 
     * @type {AnagrafeDTO}
     * @memberof DocumentoDTO
     */
    anagrafeMittente?: AnagrafeDTO;
    /**
     * 
     * @type {AnagrafeDTO}
     * @memberof DocumentoDTO
     */
    anagrafeDestinatario?: AnagrafeDTO;
}

/**
 * Check if a given object implements the DocumentoDTO interface.
 */
export function instanceOfDocumentoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentoDTOFromJSON(json: any): DocumentoDTO {
    return DocumentoDTOFromJSONTyped(json, false);
}

export function DocumentoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idCiclo': !exists(json, 'idCiclo') ? undefined : json['idCiclo'],
        'idAnagrafeMittente': !exists(json, 'idAnagrafeMittente') ? undefined : json['idAnagrafeMittente'],
        'idAnagrafeDestinatario': !exists(json, 'idAnagrafeDestinatario') ? undefined : json['idAnagrafeDestinatario'],
        'dataDocumento': !exists(json, 'dataDocumento') ? undefined : (new Date(json['dataDocumento'])),
        'numeroDocumento': !exists(json, 'numeroDocumento') ? undefined : json['numeroDocumento'],
        'dataOperazione': !exists(json, 'dataOperazione') ? undefined : (new Date(json['dataOperazione'])),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'tipo': !exists(json, 'tipo') ? undefined : json['tipo'],
        'idArxivar': !exists(json, 'idArxivar') ? undefined : json['idArxivar'],
        'ciclo': !exists(json, 'ciclo') ? undefined : CicloDTOFromJSON(json['ciclo']),
        'anagrafeMittente': !exists(json, 'anagrafeMittente') ? undefined : AnagrafeDTOFromJSON(json['anagrafeMittente']),
        'anagrafeDestinatario': !exists(json, 'anagrafeDestinatario') ? undefined : AnagrafeDTOFromJSON(json['anagrafeDestinatario']),
    };
}

export function DocumentoDTOToJSON(value?: DocumentoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idCiclo': value.idCiclo,
        'idAnagrafeMittente': value.idAnagrafeMittente,
        'idAnagrafeDestinatario': value.idAnagrafeDestinatario,
        'dataDocumento': value.dataDocumento === undefined ? undefined : (value.dataDocumento.toISOString()),
        'numeroDocumento': value.numeroDocumento,
        'dataOperazione': value.dataOperazione === undefined ? undefined : (value.dataOperazione.toISOString()),
        'note': value.note,
        'tipo': value.tipo,
        'idArxivar': value.idArxivar,
        'ciclo': CicloDTOToJSON(value.ciclo),
        'anagrafeMittente': AnagrafeDTOToJSON(value.anagrafeMittente),
        'anagrafeDestinatario': AnagrafeDTOToJSON(value.anagrafeDestinatario),
    };
}

